import {Map} from 'immutable';

export default function (confirmActionType, cancelActionType,
                         pendingActionType, fulfilledActionType, rejectedActionType) {
  const initialState = new Map({
    show: false,
    processing: false,
    user: new Map({
      id: 0,
      email: ''
    })
  });

  return function (state = initialState, action) {
    switch (action.type) {
      case confirmActionType:
        return state.withMutations(map =>
          map.set('show', true)
            .setIn(['user', 'id'], action.payload.get('id'))
            .setIn(['user', 'email'], action.payload.get('email'))
        );

      case pendingActionType:
        return state.set('processing', true);

      case cancelActionType:
      case fulfilledActionType:
        return initialState;

      case rejectedActionType:
        return state.set('processing', false);

      default:
        return state;
    }
  };
}



// WEBPACK FOOTER //
// ./app/features/users/reducers/modals/enableDisableUserReducerFactory.js